export default __webpack_public_path__ + "static/media/book-2-black.a00a0141.svg";